import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AuthSplitLayout } from '../components/ui/auth-split-layout';
import SeoHead from '../components/SeoHead';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await resetPassword(email);
      setMessage('Check your email for a password reset link.');
    } catch {
      setError('Failed to send reset email. Make sure your email is correct.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <SeoHead />
      <AuthSplitLayout>
        <div className="mb-8">
          <h1>Reset password</h1>
          <p className="sba-split-lead">Enter your email and we&apos;ll send you a reset link.</p>
        </div>

        {error ? <p className="sba-split-error">{error}</p> : null}
        {message ? <p className="sba-split-success">{message}</p> : null}

        <form onSubmit={handleSubmit} className="space-y-6" style={{ display: 'grid', gap: 16 }}>
          <label className="sba-split-field">
            Email Address
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              required
            />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send Reset Link'}
          </button>
        </form>

        <p className="sba-split-lead" style={{ marginTop: 20 }}>
          <button type="button" onClick={() => navigate('/login')} className="text-blue-600 hover:text-blue-700 font-medium">
            Back to Sign In
          </button>
        </p>
      </AuthSplitLayout>
    </>
  );
}
